import { CbhFeatureFlag } from "../../FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "../../FeatureFlags/useCbhFlag";

export function useIsCbhWrappedEnabled() {
  return useCbhFlag(CbhFeatureFlag.HACK_WEEK_CBH_WRAPPED, {
    defaultValue: false,
  });
}
